import React from 'react';
import { Button } from 'react-bootstrap';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  WarehouseDatatable = (props) => {

    const [t] = useTranslation();      
    const tableName = t('warehouse.label.warehouses'); 


    const clickHandler = (row) => {
        // console.log('clicked on: '+row.target.id);
         // let name = row.target.name;
        
         props.parentCallback(row.target.id,"edit");
     
     }


    const columns = [       
                { name: "Id", data: "id", selector: "id", omit: true},
                { name: t('general.label.name'), data: "name", sortable: true, selector: "name"},    		
                { name: t('article.label.number'), data: "number", sortable: true, selector: "number"},    		
                { name: t('itemType.label.itemType'), data: "itemType", sortable: true, selector: "itemType",
                cell:(row) => t('itemType.label.'+row.itemType)},    		
                { name: t('general.label.description'), data: "description",  sortable: true,  selector: "description"},
                {  cell:(row) => <Button onClick={clickHandler} id={row.id} name={row.name} >{t('general.button.edit')}</Button>,
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true
                }
                     
                
    ];        


            
        const columnsData = [       
            { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
            { name: t('general.label.name'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
            { name: t('article.label.number'), data: "number", orderable: true,  searchable: true, search: {value: '',regex: false}},
            { name: t('itemType.label.itemType'), data: "itemType", orderable: true,  searchable: true, search: {value: '',regex: false}},
            { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}               
     ];        
     const url = RestService.getBaseURL()+"warehouse/getList";   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 

     const handleCallback  = (id) => {
             props.parentCallback(id,"status");                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
             />
           
         );
    
 
  
 };

export default WarehouseDatatable;

